import { HotelFeatureFlags } from '@airasia-common/libraries/constants';
import { isLoggedUser } from '@airasia-common/libraries/utilities/CredentialHelper';
import { useSelector } from 'react-redux';
import { useCredential } from './useCredential';

const getHotelFeatureFlags = ({ metadata: { featureFlags = {} } }) =>
  featureFlags;

export const useHotelFeatureFlags = feature => {
  const featureFlags = useSelector(getHotelFeatureFlags);
  return featureFlags && featureFlags[feature];
};

export const useFlagHotelBookerAsSSO = () => {
  const credential = useCredential();
  return isLoggedUser(credential);
};

export const useFlagHotelEnableGuestDetailsPull = () => {
  const credential = useCredential();
  return isLoggedUser(credential);
};

export const useFlagHotelEnableTripadvisorRating = () => {
  const isTripadvisorRatingEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_TRIPADVISOR_RATING
  );
  return isTripadvisorRatingEnabled;
};

export const useFlagHotelEnableNewHotelCard = () => {
  const isNewHotelCardEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_NEW_HOTEL_CARD
  );
  return isNewHotelCardEnabled;
};

export const useFlagHotelMandateLogin = () => {
  const isHotelLoginMandated = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_MANDATE_LOGIN_WEB
  );
  return isHotelLoginMandated;
};

export const useEnablegoogleAds = () => {
  const isShowGoogleAds = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_LIST_GOOGLE_ADS_SIZE
  );
  return isShowGoogleAds;
};

export const useEnableGadsListingWeb = () => {
  const isShowGoogleAds = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_GOOGLEADS_LISTING_WEB
  );
  return isShowGoogleAds;
};

export const useEnableIndexAds = () => {
  const isShowGoogleAds = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_INDEX_OF_ADS_LSTINGPAGE
  );
  return isShowGoogleAds;
};
export const useFlagGuestDetailsFeedback = () => {
  const isShowGuestDetailsFeedback = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_GUEST_DETAILS_FEEDBACK
  );
  return isShowGuestDetailsFeedback;
};

export const useFlagVoucherBanner = () => {
  const enableVoucherBanner = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_VOUCHER_BANNER_WEB
  );
  return enableVoucherBanner;
};

export const useFlagEnableDealOFTheDay = () => {
  const isDoDEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_DEAL_OF_THE_DAY_WEB
  );
  return isDoDEnabled;
};

export const useFlagEnableDealOFTheDayTime = () => {
  const doDTime = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_DEAL_OF_THE_DAY_TIME
  );
  return doDTime;
};

export const useFlagEnableNoHotelAvailable = () => {
  const isHotelNotAvailable = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_HOTEL_NOT_AVAILABLE_WEB
  );
  return isHotelNotAvailable;
};

export const useFlagEnableFilterRearrangeWeb = () => {
  const isFilterRearrangeWebEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_FILTER_REARRANGEMENT_WEB
  );
  return isFilterRearrangeWebEnabled;
};

export const useSelectButtonRoomHotelCard = () => {
  const isSelectRoomLabelEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_SELECT_ROOM_LABEL_HOTEL_WEB
  );
  return isSelectRoomLabelEnabled;
};

export const useFlagEnableBigPayCardPromo = () => {
  const isBigPayCardPromoEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_BIGPAY_CARD_PROMO_WEB
  );
  return isBigPayCardPromoEnabled;
};

export const useFlagEnableGuestRatingDeselectWeb = () => {
  const isGuestRatingDeselectWebEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_HOTEL_GUEST_RATING_DISELECT_WEB
  );
  return isGuestRatingDeselectWebEnabled;
};

export const useFlagEnableHotelCityCenterDistancePoi = () => {
  const isHotelCityCenterDistancePoiEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_DISTANCE_FROM_CITY_CENTER_WEB
  );
  return isHotelCityCenterDistancePoiEnabled;
};

export const useFlagEnableGoogleAdsHotelsWeb = () => {
  const isGoogleAdsEnabled = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_GOOGLE_ADS_WEB
  );
  return isGoogleAdsEnabled;
};

export const useFlagEnableHotelSoldout = () => {
  const isEnableHotelSoldout = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_SOLD_OUT_WEB
  );
  return isEnableHotelSoldout;
};

export const useFlagEnablePromoCodeWeb = () => {
  const isEnablePromoCodeWeb = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PROMO_CODE_ENABLED_WEB
  );
  return isEnablePromoCodeWeb;
};

export const useFlagEnableFomoMessagesWeb = () => {
  const value = useHotelFeatureFlags(HotelFeatureFlags.HOTEL_FOMO_MESSAGES_WEB);
  return value;
};

export const useFlagEnablePromoBannerWeb = () => {
  const isEnablePromoBannerWeb = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PROMO_BANNER_ENABLED_WEB
  );
  return isEnablePromoBannerWeb;
};

export const useFlagEnableSubscriptionBannerWeb = () => {
  const isEnableSubscriptionBannerWeb = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_USER_SUBSCRIPTION_WEB
  );
  return isEnableSubscriptionBannerWeb;
};

export const useFlagFastFillingFomo = () => {
  const fastFillingFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_FAST_FILLING_FOMO
  );
  return fastFillingFomo;
};

export const useFlagFomoMessageWeb = () => {
  const isFomoMessageWeb = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_FOMO_MESSAGES_WEB
  );
  return isFomoMessageWeb;
};

export const useFlagBookingDoneFomo = () => {
  const isHotelBookingFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_BOOKINGS_DONE_FOMO
  );
  return isHotelBookingFomo;
};

export const useFlagHotelLastRoomFomo = () => {
  const isLastRoomFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_LAST_ROOM_FOMO
  );
  return isLastRoomFomo;
};

export const useFlagHotelLastRoomCountFomo = () => {
  const isLastRoomCountFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_LAST_ROOM_COUNT_FOMO
  );
  return isLastRoomCountFomo;
};

export const useFlagHotelPriceDropFomo = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PRICE_DROP_FOMO
  );
  return isHotelPriceDropFomo;
};
export const useFlagEnableHotelBogoPromoDiscountId = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_BOGO_DISCOUNT_ID
  );
  return isHotelPriceDropFomo;
};
export const useFlagEnableHotelBogoPromo = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_BOGO_PROMO_WEB
  );
  return isHotelPriceDropFomo;
};
export const useFlagEnableBogoToggle = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_BOGO_TOGGLE_BANNER_WEB
  );
  return isHotelPriceDropFomo;
};
export const useFlagEnablePaynow = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PAYNOW_FILTER_LISTING_WEB
  );
  return isHotelPriceDropFomo;
};
export const useFlagEnablePayLater = () => {
  const isPayLater = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PAYLATER_TAG_LISTING_WEB
  );
  return isPayLater;
};
export const useFlagGoogleMapsColored = () => {
  const isHotelPriceDropFomo = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_GOOGLEMAPS_COLORED_WEB
  );
  return isHotelPriceDropFomo;
};
export const useFlagPromoCodeHotelIDs = () => {
  const isEnablePromoCode = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_LISTING_PROMO_CODE_IDS
  );
  return isEnablePromoCode;
};

export const useFlagHotelPaynowPromoIds = () => {
  return useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_PAYNOW_PROMO_CODE_IDS_WEB
  );
};

export const useFlagEnablePayNowForPaymentOption = () => {
  return useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_DEFAULT_PAY_NOW_SELECTION_WEB
  );
};

export const useFlagPayNowTagEnabled = () => {
  return useHotelFeatureFlags(HotelFeatureFlags.HOTEL_PAYNOW_TAG_LISTING_WEB);
};

export const useFlagRebrandEnabled = () => {
  return useHotelFeatureFlags(HotelFeatureFlags.ENABLE_REBRANDING_HOTEL_WEB);
};

export const useFlagEnableCrossSellBannerWeb = () => {
  const isEnableCrossSellBannerWeb = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_CROSS_SELL_BANNER_WEB
  );
  return isEnableCrossSellBannerWeb;
};

export const useFlagEnableFlyerDiscountImgWeb = () => {
  const isEnableFlyerDiscountImgWeb = useHotelFeatureFlags(
    HotelFeatureFlags.FLYER_DISCOUNT_BANNER_IMG_WEB
  );
  return isEnableFlyerDiscountImgWeb;
};

export const useFlagEnableCrossSellDiscountPercentage = () => {
  const isEnableCrossSellDiscountPercentage = useHotelFeatureFlags(
    HotelFeatureFlags.CROSS_SELL_DISCOUNT_PERCENTAGE
  );
  return isEnableCrossSellDiscountPercentage;
};

export const useFlagEnableCrossSellPromoCode = () => {
  const isEnableCrossSellPromoCode = useHotelFeatureFlags(
    HotelFeatureFlags.CROSS_SELL_PROMO_CODE
  );
  return isEnableCrossSellPromoCode;
};

export const useFlagEnableCrossSellPercentValue = () => {
  const isEnableCrossSellPercentValue = useHotelFeatureFlags(
    HotelFeatureFlags.CROSS_SELL_PERCENT_VALUE
  );
  return isEnableCrossSellPercentValue;
};
export const useFlagBogoDiscountBannerImageWeb = () => {
  const bogoDiscountBannerImageApp = useHotelFeatureFlags(
    HotelFeatureFlags.BOGO_DISCOUNT_BANNER_IMG_WEB
  );
  return bogoDiscountBannerImageApp;
};
export const useFlagBogoDiscountPercentage = () => {
  const bogoDiscountPercentage = useHotelFeatureFlags(
    HotelFeatureFlags.BOGO_DISCOUNT_PERCENTAGE
  );
  return bogoDiscountPercentage;
};
export const useFlagBogoPromoCode = () => {
  const bogoPromoCode = useHotelFeatureFlags(HotelFeatureFlags.BOGO_PROMO_CODE);
  return bogoPromoCode;
};
export const useFlagBogoPercentValue = () => {
  const bogoPercentValue = useHotelFeatureFlags(
    HotelFeatureFlags.BOGO_PERCENT_VALUE
  );
  return bogoPercentValue;
};
export const useFlagRM9DiscountBannerImageWeb = () => {
  const rm9DiscountBannerImageApp = useHotelFeatureFlags(
    HotelFeatureFlags.RM9_DISCOUNT_BANNER_IMG_WEB
  );
  return rm9DiscountBannerImageApp;
};
export const useFlagRM9DiscountPercentage = () => {
  const rm9DiscountPercentage = useHotelFeatureFlags(
    HotelFeatureFlags.RM9_DISCOUNT_PERCENTAGE
  );
  return rm9DiscountPercentage;
};
export const useFlagRM9PromoCode = () => {
  const rm9PromoCode = useHotelFeatureFlags(HotelFeatureFlags.RM9_PROMO_CODE);
  return rm9PromoCode;
};
export const useFlagRM9PercentValue = () => {
  const rm9PercentValue = useHotelFeatureFlags(
    HotelFeatureFlags.RM9_PERCENT_VALUE
  );
  return rm9PercentValue;
};
export const useFlagPromoDiscountLocations = () => {
  const promoDiscountLocations = useHotelFeatureFlags(
    HotelFeatureFlags.PROMO_DISCOUNT_LOCATIONS
  );
  return promoDiscountLocations;
};
export const useFlagEnableFlyerDiscount = () => {
  const isEnableFlyerDiscountValue = useHotelFeatureFlags(
    HotelFeatureFlags.HOTEL_ENABLE_FLYER_DISCOUNT_WEB
  );
  return isEnableFlyerDiscountValue;
};
export const useFlagEnableRM9Button = () => {
  const isEnableRM9Button = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_HOTEL_CARD_RM9_BUTTON_WEB
  );
  return isEnableRM9Button;
};
export const useFlagEnableRM9SpecialCurrency = () => {
  const RM9SpecialCurrency = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_ROUND_SAVINGLABEL_CURRENCY
  );
  return RM9SpecialCurrency;
};
export const useFlagEnableEInvoiceConfirmationpage = () => {
  const EInvoiceEnable = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_EINVOICE_CONFIRMATION_PAGE
  );
  return EInvoiceEnable;
};
export const useEnablePriceBucketsConfig = () => {
  const enablePriceBucketsConfig = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_PRICEBUCKETS_FROM_CONFIG_WEB
  );
  return enablePriceBucketsConfig;
};
export const usePriceBucketsConfig = currency => {
  const priceBucketsConfig = useHotelFeatureFlags(
    `PER_PERSION_PRICE_FILTER_BUCKETS_FOR_${currency.toUpperCase()}`
  );
  return priceBucketsConfig?.split(',');
};
export const useFlagEnableLemonADT = () => {
  const isEnableLemonADT = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_LEMON_ADT_DUTYTRAVEL
  );
  return isEnableLemonADT;
};

export const useFlagEnabledOracleIdField = () => {
  const isEnabledOracleIdField = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_ORACLE_ID_FIELD
  );
  return isEnabledOracleIdField;
};

export const useEnablePreCheckoutCallGuestDetails = () => {
  const isEnabledPreCheckoutCallGuest = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_WEB
  );
  return isEnabledPreCheckoutCallGuest;
};

export const useEnablePreCheckoutCall = () => {
  const isEnabledPreCheckoutCall = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_PRE_CHECKOUT_CALL_WEB
  );
  return isEnabledPreCheckoutCall;
};

export const useEnableNewIPURL = () => {
  const enableNewIPURL = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_NEW_IP_URL_WEB
  );
  return enableNewIPURL;
};
export const useEnableSEOData = () => {
  const isEnabledSEOData = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_SEO_DATA
  );
  return isEnabledSEOData;
};

export const useEnableBlockedRate = () => {
  return useHotelFeatureFlags(HotelFeatureFlags.ENABLE_BLOCKED_RATES_WEB);
};

export const useEnableSendingMFTParameter = () => {
  const isEnableSendingMFTParameter = useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_SENDING_MFT_PARAMETER
  );
  return isEnableSendingMFTParameter;
};

export const useEnableSupportedCurrencies = () => {
  const supportedCurrencies = useHotelFeatureFlags(
    HotelFeatureFlags.SUPPORTED_CURRENCIES
  );
  return supportedCurrencies;
};

export const useFlagEnableExtraRoomAmenities = () => {
  return useHotelFeatureFlags(
    HotelFeatureFlags.ENABLE_EXTRA_ROOM_AMENITIES_WEB
  );
};
